module.exports = __webpack_public_path__ + "static/media/search-products-filter.d7fa9730.svg";